import React, { useState, useEffect, useMemo, forwardRef } from 'react'
import { Upload, Button, Popover, message } from 'antd'
import { RcFile, UploadChangeParam } from 'antd/lib/upload/interface'
import { InboxOutlined, UploadOutlined } from '@ant-design/icons'
import createAbsoluteGrid from 'react-absolute-grid'
import * as _ from 'lodash'
import { stopPropagation } from '../../../utils'
import { getAuth } from '../../../utils/global'
import {WebCrawlerModal, ContentSelect } from './components'
import { LeadBusiness }from '../../index'
import './index.less'
export type ContentType = '图片' | '视频' | '音频' | '文章'
const zoom = 1

export interface ContentDataType {
	st_fileurl?: string;
	st_text_content?: string;
	type: ContentType;
}

export interface SelectMaterialProps {
	value?: ContentDataType; // TODO 确认
	nameList: string[];
	businessList: string[];
	isUpdate: boolean;
	dragEnabled: boolean;
	selectContentVisilbe: boolean;
	onChange?: (val: string | ContentDataType[]) => void;
	onTempFileChange?: (val: RcFile) => void; // 记录临时的原始文件
	dragItemWidth: number;
}
const ShowImg = React.memo((props) => {
	console.log(props)
	return <div></div>
})
const SelectMaterial: React.FC<SelectMaterialProps> = forwardRef((props, ref) => {
	const { onChange, isUpdate, onTempFileChange, dragEnabled, businessList, selectContentVisilbe, value, nameList, dragItemWidth } = props
	const [funcAuth, setFuncAuth] = useState([])
	const [fileList, setFileList] = useState<any>(value?.st_fileurl || [])
	const [leadBusinessVisible, setLeadBusinessVisible]=useState<boolean>(false)
	const [webCrawlerVisible, setWebCrawlerVisible] = useState<boolean>(false)
	const [contentSelectVisible, setContentSelectVisible] = useState<boolean>(false)
	const canReadBussines = useMemo(() => funcAuth.find(item => item.resourceVal === 'canReadBussines'), [funcAuth]) // 业务数据可读权限
	const [firstFileurl, setFirstFileurl] = useState('')
	const checkFileType = (type) => {
		if(type.includes('video/')) {
			return '视频'
		}
		if(type.includes('image/')) {
			return '图片'
		}
		if(type.includes('audio/')) {
			return '音频'
		}
		return ''
	}
	// 防止一进入就提示请选择素材
	const onChangeFileList = (list) => {
		setFileList(list)
		onChange && onChange(list)
	}
	const fileListSort = (value) => {
		const newFileList = [...fileList, ...value]
		if(isUpdate) newFileList.length = 1 // 添加内容编辑时不支持批量
		newFileList.map((item, index) => {
			item.sort = index
			item.key = index
			if(!item.status) item.status = 'done'
		})
		console.log('排序')
		onChangeFileList(newFileList)
	}

	useEffect(() => {
		getAuth('function').then(res => { // 方法权限
			setFuncAuth(res)
		})
	}, [])

	useEffect(() => {
		// 素材改变 重新计算 分辨率和尺寸
		if (value && Object.prototype.toString.call(value) === '[object Array]' && value.length) {
			if(firstFileurl !== value[0].st_fileurl) {
				console.log('第一张素材改变及编辑进入', value)
				setFirstFileurl(value[0].st_fileurl)
				onChangeFileList(value)
			}
		}
	}, [value])

	const handleChange = ({ file }: UploadChangeParam): void => {
		const { status, response, type } = file
		if (file.status === 'uploading') {
			const newFileList = [...fileList]
			const isHave = newFileList.find(item => item.uid === file.uid)
			if(!isHave) {
				newFileList.push({
					type: '',
					st_fileurl: file.uid,
					status: 'uploading',
					uid: file.uid,
					name: file.name
				})
				newFileList.map((item, index) => {
					item.sort = index
					item.key = index
				})
				onChangeFileList(newFileList)
			}
		}
		if (status === 'done' && response.code === 0) {
			const updateUrl = response.data
			const newFileList = [...fileList]
			newFileList.map(item => {
				if(item.uid === file.uid) {
					item.type= checkFileType(type)
					item.st_fileurl= updateUrl
					item.status= 'done'
				}
			})
			onChangeFileList(newFileList)
		}
		console.log(status)
		if(status === 'error') {
			const newFileList = [...fileList]
			newFileList.map(item => {
				if(item.uid === file.uid) {
					item.status= 'error'
				}
			})
			onChangeFileList(newFileList)
		}
	}

	const beforeUpload = (file: RcFile): boolean => {
		onTempFileChange && onTempFileChange(file)
		return true
	}

	// 业务数据
	const handleLeadBusiness= (value) => {
		setLeadBusinessVisible(value)
	}
	const leadFromBusiness = (e) => {
		stopPropagation(e)
		handleLeadBusiness(true)
		console.log('leadFromBusiness',leadBusinessVisible)

	}
	const handleLeadBusinessData = (val) => {
		console.log('here:', val)
		fileListSort(val)
	}
	const leadBusinessProps = {
		visible: leadBusinessVisible,
		handleLeadBusiness,
		handleLeadBusinessData,
	}
	// 从网页中提取
	const webCrawlerProps = {
		visible: webCrawlerVisible,
		handleVisible: (val: boolean) => {
			setWebCrawlerVisible(val)
		},
		onSuccess: (val: ContentDataType[]) => {
			console.log('从网页中提取成功：', val)
			fileListSort(val)
		},
	}
	const grabFromWeb = (e) => {
		stopPropagation(e)
		webCrawlerProps.handleVisible(true)
	}
	//内容库选择
	const contentSelectProps = {
		contentSelectVisible,
		nameList,
		value: fileList,
		handleContentSelectVisible: (val) => {
			setContentSelectVisible(val)
		},
		onSuccess: (val) => {
			console.log('onSuccess', val)
			fileListSort(val)
		}
	}
	const selectFromContent = (e) => {
		stopPropagation(e)
		contentSelectProps.handleContentSelectVisible(true)
		console.log('selectFromContent')
	}
	const dropContent = (
		<div className="drop-down-menu">
			{selectContentVisilbe && <div className="menu-item" onClick={selectFromContent}>内容库</div>}
			<div className="menu-item" onClick={grabFromWeb}>网页提取</div>
			{canReadBussines && <div className="menu-item" onClick={leadFromBusiness}>业务数据</div>}
			<div className="menu-item">
				<Upload
					action={`${process.env.REACT_APP_BASE_URL}/infoManage/addFile`}
					accept="video/mp4,video/x-m4v,video/*,image/*,audio/*"
					onChange={handleChange}
					withCredentials={true}
					showUploadList={false}
					multiple
				>
					本地上传
				</Upload>
			</div>
		</div>
	)
	const delMaterial = (value, type= '') => {
		const newFileList = [...fileList]
		console.log(value)
		newFileList.map((item, index) => {
			if(type === 'text') {
				if(item.st_text_content === value.st_text_content) {
					newFileList.splice(index, 1)
					onChangeFileList(newFileList)
					return

				}
			}
			if(item.st_fileurl === value.st_fileurl && type === '') {
				newFileList.splice(index, 1)
				onChangeFileList(newFileList)
				return
			}
		})
	}
	const FileItem: React.FC = (data) => {
		const item = data.item
		return (
			<div className="material-item" key={item.st_fileurl}>
				{item.status === 'done' || item.st_fileurl.indexOf('http') > -1 ?
					item.type === '视频' && !item.st_thumbnail && (item.st_fileurl.includes('.MP4') || item.st_fileurl.includes('.mp4')) ?
						<video src={item.st_fileurl}></video>
						:
						<img src={item.type === '图片' ?
							item.st_fileurl : item.type === '视频' ?
								item.st_thumbnail ? item.st_thumbnail
									: 'http://m.elongstatic.com/cdc/com-static/video.png'
								: 'http://m.elongstatic.com/cdc/com-static/music.png'} alt="图片"/>
					: <div style={{height: '100%', justifyContent: 'center', display: 'flex', alignItems: 'center'}}>{item.status === 'uploading' ? '上传中...' : '上传失败'}</div>
				}
				<div className="del" onClick={() => delMaterial(item)}>
				</div>
			</div>
		)

	}
	const onMove = function(source, target){
		let newFileList = [...fileList]
		source = _.find(newFileList, {key: parseInt(source, 10)})
		target = _.find(newFileList, {key: parseInt(target, 10)})

		const targetSort = target.sort
		// console.log(source,target)
		newFileList = newFileList.map(function(item){
			if(item.key === source.key) {
				return {
					...item,
					sort: targetSort
				}
			} else if(target.sort > source.sort && (item.sort <= target.sort && item.sort > source.sort)){
				return {
					...item,
					sort: item.sort - 1
				}
			} else if (item.sort >= target.sort && item.sort < source.sort){
				return {
					...item,
					sort: item.sort + 1
				}
			}
			return item
		})
		const newSortFileList = []
		newFileList.map(item => {
			newSortFileList[item.sort] = item
		})
		onChangeFileList(newSortFileList)
	}
	const AbsoluteGrid = createAbsoluteGrid(FileItem)
	const onMoveDebounced = _.debounce(onMove, 40)
	return (<>
		<div>
			<div>
				<Upload.Dragger
					className="content-upload-drag-box"
					action={`${process.env.REACT_APP_BASE_URL}/infoManage/addFile`}
					beforeUpload={beforeUpload}
					onChange={handleChange}
					showUploadList={false}
					withCredentials={true}
					multiple={!isUpdate}
					accept="video/mp4,video/x-m4v,video/*,image/*,audio/*"
					openFileDialogOnClick={fileList.length ? false : true}
				>
					{fileList.length > 0 ?
						<div className="uploaded-wrap">
							<div className="material-list-wrap2">
								{/* {JSON.stringify(fileList)} */}
								<div className="material-list clearfix">
									<AbsoluteGrid
										items={fileList.filter(item => {return item.type !== '文章'})}
										onMove={onMoveDebounced}
										dragEnabled={dragEnabled}
										zoom={zoom}
										responsive={true}
										verticalMargin={0}
										itemWidth={dragItemWidth}
										itemHeight={dragItemWidth+8}
									/>
								</div>
								<div className="material-text-list">
									{
										fileList.filter(item => { return item.type === '文章'}).map((text, index) => {
											return (
												<div className="material-text-item" key={index}>
													<div className="del" onClick={() => delMaterial(text, 'text')}>
													</div>
													<div dangerouslySetInnerHTML={{__html: text.st_text_content}}></div>
												</div>
											)
										})
									}
								</div>
							</div>
							{!isUpdate &&
							<div className="goOnUpload">
								<p className="tips">1.请上传图片、视频等素材，格式不限，单个文件大小上限为300M<br></br>2.默认按素材顺序混剪，拖动上方素材可调整剪辑顺序</p>

								<Popover overlayClassName="upload-popover" content={dropContent}>
									<Button type="primary"><UploadOutlined/>继续上传</Button>
								</Popover>
							</div>
							}
						</div>
						:
						<div>
							<p className="upload-drag-icon">
								<InboxOutlined />
							</p>
							<p className="upload-text">
								<span>将文件拖拽到此处</span>
							</p>
							<p className="upload-text upload-tips">添加素材，格式不限，单个文件大小上限为300M</p>
							<div className="btnArea">
								{selectContentVisilbe && <Button type="primary" ghost size="middle" onClick={selectFromContent}>内容库添加</Button>}
								{canReadBussines && <Button type="primary" ghost size="middle" onClick={leadFromBusiness}>业务数据</Button>}
								<Button type="primary" ghost size="middle" onClick={grabFromWeb}>网页提取</Button>
								<Button type="primary" ghost size="middle">本地上传</Button>
							</div>
						</div>
					}
				</Upload.Dragger>

				{/* 业务数据 */}
				<LeadBusiness
					{...leadBusinessProps}
				/>
				{/* 从网页中提取 */}
				<WebCrawlerModal {...webCrawlerProps}/>
				{/* 内容库选择 */}
				<ContentSelect {...contentSelectProps}/>
			</div>
		</div>
	</>
	)
})

SelectMaterial.defaultProps = {
	onChange: null,
	isUpdate:false, // 仅添加内容时编辑传入 true
	onTempFileChange: null,
	dragEnabled:false,
	businessList: ['图片', '视频', '文字'],
	selectContentVisilbe: false,
	value: null,
	nameList: [],
	dragItemWidth: 80
}
export default SelectMaterial